// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.help-text[data-v-f1302a92] {\n    opacity: 0.8;\n}\n", ""]);
// Exports
module.exports = exports;
